"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Container_1 = require("../components/Container");
var Link_1 = __importDefault(require("../components/Link/Link"));
var Default401 = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h1", null, "401: P\u0159\u00EDstup odep\u0159en z d\u016Fvodu nedostate\u010Dn\u00E9ho opr\u00E1vn\u011Bn\u00ED"),
    react_1.default.createElement("p", null, "Pro zobrazen\u00ED p\u0159\u00EDslu\u0161n\u00E9ho z\u00E1znamu nem\u00E1te pot\u0159ebn\u00E1 opr\u00E1vn\u011Bn\u00ED."))); };
var Default404 = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h1", null, "404 - Str\u00E1nka nenalezena"),
    react_1.default.createElement("p", null, "Str\u00E1nka, kterou se sna\u017E\u00EDte zobrazit byla pravd\u011Bpodobn\u011B p\u0159esunuta na jin\u00E9 m\u00EDsto."))); };
var Default400 = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h1", null, "400 - Chyba klienta"),
    react_1.default.createElement("p", null, "P\u0159i na\u010D\u00EDt\u00E1n\u00ED po\u017Eadovan\u00E9 str\u00E1nky nastala chyba."))); };
var Default500 = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h1", null, "500 - Chyba serveru"),
    react_1.default.createElement("p", null, "P\u0159i na\u010D\u00EDt\u00E1n\u00ED po\u017Eadovan\u00E9 str\u00E1nky nastala chyba."))); };
var Content = function (_a) {
    var message = _a.message, status = _a.status;
    if (!message) {
        switch (status.toString()) {
            case '401':
                return react_1.default.createElement(Default401, null);
            case '404':
                return react_1.default.createElement(Default404, null);
            case '500':
                return react_1.default.createElement(Default500, null);
            default:
                return react_1.default.createElement(Default400, null);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h1", null,
            "Chyba ",
            status),
        react_1.default.createElement("p", null, message)));
};
Content.defaultProps = {
    message: undefined,
};
var ErrorPage = function (_a) {
    var status = _a.status, message = _a.message;
    return (react_1.default.createElement(Container_1.TransparentContainer, null,
        react_1.default.createElement(Content, { status: status, message: message }),
        react_1.default.createElement("p", null, "N\u00E1sleduj\u00EDc\u00ED odkaz by V\u00E1m mohl pomoci:"),
        react_1.default.createElement(Link_1.default, { to: "/" }, "Zp\u011Bt na hlavn\u00ED stranu")));
};
ErrorPage.defaultProps = {
    message: undefined,
};
exports.default = ErrorPage;
